(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.ReutsCircleTickets = api;

    const initialize = function () {
      api.init(root.document);
    };

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function clampQuantity(quantity, maximum) {
    const parsedMaximum = Number.parseInt(maximum, 10);
    const safeMaximum = Number.isFinite(parsedMaximum)
      ? Math.min(Math.max(parsedMaximum, 1), 4)
      : 4;
    const parsedQuantity = Number.parseInt(quantity, 10);
    const safeQuantity = Number.isFinite(parsedQuantity) ? parsedQuantity : 1;

    return Math.min(Math.max(safeQuantity, 1), safeMaximum);
  }

  function ticketSummary(quantity, unitPriceCents, currencyCode) {
    const safeQuantity = clampQuantity(quantity, 4);
    const parsedPrice = Number.parseInt(unitPriceCents, 10);
    const safePrice = Number.isFinite(parsedPrice) ? Math.max(parsedPrice, 0) : 0;
    const totalCents = safeQuantity * safePrice;
    const hasFraction = totalCents % 100 !== 0;
    const formattedNumber = new Intl.NumberFormat('he-IL', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(totalCents / 100);
    const currencySymbols = {
      ILS: '₪',
      USD: '$',
      EUR: '€',
      GBP: '£',
    };
    const currency = currencySymbols[currencyCode] || currencyCode || '';
    const total = `${formattedNumber}${currency ? ` ${currency}` : ''}`;
    const ticketLabel = safeQuantity === 1 ? 'כרטיס אחד' : `${safeQuantity} כרטיסים`;

    return {
      ticketLabel,
      total,
      text: `${ticketLabel} · ${total}`,
    };
  }

  function cartPermalink(rootUrl, variantId, quantity) {
    const normalizedRoot = String(rootUrl || '/').replace(/\/?$/, '/');
    const safeQuantity = clampQuantity(quantity, 4);

    return `${normalizedRoot}cart/${variantId}:${safeQuantity}`;
  }

  function syncTicketRoot(root, quantity) {
    const maximum = clampQuantity(root.dataset.ticketMax, 4);
    const safeQuantity = clampQuantity(quantity, maximum);
    const summary = ticketSummary(
      safeQuantity,
      root.dataset.ticketUnitPrice,
      root.dataset.ticketCurrency,
    );
    const checkoutHref = cartPermalink(
      root.dataset.ticketCartRoot,
      root.dataset.ticketVariantId,
      safeQuantity,
    );

    root.dataset.ticketQuantity = String(safeQuantity);
    root.querySelectorAll('[data-ticket-value]').forEach(function (element) {
      element.textContent = String(safeQuantity);
    });
    root.querySelectorAll('[data-ticket-decrement]').forEach(function (button) {
      button.disabled = safeQuantity <= 1;
    });
    root.querySelectorAll('[data-ticket-increment]').forEach(function (button) {
      button.disabled = safeQuantity >= maximum;
    });
    root.querySelectorAll('[data-ticket-summary]').forEach(function (element) {
      element.textContent = summary.text;
    });
    root.querySelectorAll('[data-ticket-checkout]').forEach(function (link) {
      link.setAttribute('href', checkoutHref);
      link.setAttribute(
        'aria-label',
        `${root.dataset.ticketCheckoutLabel} — ${summary.text}`,
      );
    });

    return safeQuantity;
  }

  function init(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;

    scope.querySelectorAll('[data-reuts-ticket-root]').forEach(function (root) {
      if (root.dataset.ticketEnhanced === 'true') return;

      let quantity = syncTicketRoot(root, 1);
      root.dataset.ticketEnhanced = 'true';

      root.addEventListener('click', function (event) {
        const incrementButton = event.target.closest('[data-ticket-increment]');
        const decrementButton = event.target.closest('[data-ticket-decrement]');
        const control = incrementButton || decrementButton;

        if (!control || !root.contains(control) || control.disabled) return;

        quantity = syncTicketRoot(root, quantity + (incrementButton ? 1 : -1));
      });
    });
  }

  return {
    cartPermalink,
    clampQuantity,
    init,
    syncTicketRoot,
    ticketSummary,
  };
});
